export default __webpack_public_path__ + "static/media/1666E192-8426-467E-9CCC-316E8754DA24.015dabff.jpeg";